import type { Key } from './en';

/** Arabic (RTL, IBM Plex Sans Arabic). Product names, amounts and ids stay in Latin script with Western digits.
 *  Native-speaker review pending. */
export const ar: Partial<Record<Key, string>> = {
  'nav.main': 'القائمة الرئيسية',
  'nav.home': 'الرئيسية',
  'nav.home.overview': 'نظرة عامة',
  'nav.home.today': 'اليوم في الموقع',
  'nav.home.weekly': 'التقرير الأسبوعي',
  'nav.projects': 'المشاريع',
  'nav.projects.all': 'كل المشاريع',
  'nav.projects.stages': 'المراحل والتقدم',
  'nav.projects.timeline': 'الجدول الزمني',
  'nav.projects.files': 'المخططات والملفات',
  'nav.projects.diary': 'يومية الموقع',
  'nav.projects.photos': 'الصور',
  'nav.office': 'مكتب الموقع',
  'nav.office.attendance': 'الحضور',
  'nav.office.wages': 'كشف الأجور',
  'nav.office.workers': 'العمال والفرق',
  'nav.office.todos': 'المهام',
  'nav.office.visitors': 'الزوار',
  'nav.stores': 'المخازن',
  'nav.stores.stock': 'المخزون في الموقع',
  'nav.stores.receive': 'الاستلام',
  'nav.stores.issue': 'الصرف للعمل',
  'nav.stores.transfers': 'التحويلات',
  'nav.stores.water': 'صهاريج المياه',
  'nav.stores.debris': 'شاحنات المخلفات',
  'nav.buy': 'المشتريات',
  'nav.buy.requests': 'الطلبات',
  'nav.buy.quotations': 'عروض الأسعار',
  'nav.buy.orders': 'أوامر الشراء',
  'nav.buy.suppliers': 'الموردون',
  'nav.money': 'المال',
  'nav.money.budget': 'الميزانية والتقدير',
  'nav.money.changes': 'أوامر التغيير',
  'nav.money.invoices': 'فواتير العميل',
  'nav.money.bills': 'فواتير الموردين',
  'nav.money.petty': 'العهدة النقدية',
  'nav.money.payments': 'المدفوعات',
  'nav.money.tax': 'الضريبة',
  'nav.clients': 'العملاء',
  'nav.clients.links': 'روابط العملاء',
  'nav.clients.selections': 'الاختيارات',
  'nav.clients.enquiries': 'الاستفسارات',
  'nav.reports': 'التقارير',
  'nav.reports.progress': 'التقدم',
  'nav.reports.cost': 'التكلفة مقابل الميزانية',
  'nav.reports.stock': 'المخزون والمياه',
  'nav.reports.attendance': 'الحضور والأجور',
  'nav.reports.export': 'التصدير',
  'nav.settings': 'الإعدادات',
  'nav.settings.company': 'الشركة والمواقع',
  'nav.settings.people': 'الأشخاص والأدوار',
  'nav.settings.templates': 'القوالب والأسعار',
  'nav.settings.plan': 'الخطة والفوترة',
  'nav.settings.export': 'تصدير بياناتي',
  'nav.approvals': 'الموافقات',
  'nav.later': 'لاحقاً',
  'nav.by': 'Buildiary من SMH Global Services',
  'nav.openMenu': 'فتح القائمة',
  'nav.closeMenu': 'إغلاق القائمة',
  'nav.collapse': 'طي القائمة',
  'nav.expand': 'توسيع القائمة',
  'nav.breadcrumb': 'المسار',
  'nav.skip': 'انتقل إلى المحتوى',
  'nav.home.link': 'Buildiary الرئيسية',

  'top.search': 'ابحث أو انتقل إلى…',
  'top.project': 'المشروع',
  'top.projects': 'المشاريع',
  'top.allProjects': 'كل المشاريع ({n})',
  'top.siteDate': 'تاريخ الموقع',
  'top.approvals': 'الموافقات، {n} بانتظارك',
  'top.notifications': 'الإشعارات، {n} جديدة',
  'top.notesTitle': 'الإشعارات',
  'top.noNotes': 'لا جديد اليوم.',
  'top.language': 'اللغة',
  'top.account': 'الحساب',
  'top.signOut': 'تسجيل الخروج',
  'top.changePin': 'تغيير رمز PIN',
  'top.gateMode': 'وضع البوابة (جهاز لوحي)',
  'top.feedback': 'إرسال ملاحظات',
  'top.switchProject': 'تبديل المشروع',
  'top.demo': 'مساحة العرض التجريبي',

  'pal.title': 'ابحث أو انتقل إلى',
  'pal.placeholder': 'اكتب صفحة أو عاملاً أو صنفاً أو مورداً أو رقماً…',
  'pal.goTo': 'انتقل إلى',
  'pal.found': 'النتائج',
  'pal.none': 'لا توجد نتائج.',
  'pal.searching': 'جارٍ البحث…',
  'pal.navigate': 'للتنقل',
  'pal.select': 'للفتح',

  'si.kicker': 'مساحة العرض التجريبي',
  'si.kickerLive': 'إدارة مواقع البناء',
  'si.headline': 'موقع البناء الخاص بك، على هاتفك.',
  'si.promise': 'صورة واسم ووقت على كل إدخال، ليرى المالك والمقاول الحقائق نفسها.',
  'si.f1': 'الحضور ببطاقة الموقع أو رمز PIN عند البوابة',
  'si.f2': 'المخازن وصهاريج المياه وشاحنات المخلفات، كلٌّ منها بصورة',
  'si.f3': 'تقرير أسبوعي للمالك بالإنجليزية أو الأردية أو العربية',
  'si.endorse': 'منتج من SMH Global',
  'si.title': 'تسجيل الدخول',
  'si.lead': 'استخدم بريد العمل، أو اختر شخصاً أدناه لتجربة العرض.',
  'si.leadLive': 'استخدم بريد العمل أو الهاتف وكلمة المرور.',
  'si.email': 'البريد أو الهاتف',
  'si.password': 'كلمة المرور',
  'si.passwordDemo': 'غير مطلوبة في العرض التجريبي',
  'si.continueAs': 'المتابعة باسم {name}',
  'si.signIn': 'تسجيل الدخول',
  'si.or': 'أو جرّب العرض باسم',
  'si.demoNote': 'يستخدم العرض التجريبي مواقع نموذجية ويحفظ كل شيء في هذا المتصفح. لبدء مساحة عملك، اذهب إلى',
  'si.staff': 'عمال الموقع: سجّل الدخول بالبطاقة أو رمز PIN',
  'si.staffTitle': 'الدخول ببطاقة الموقع أو رمز PIN',
  'si.staffLead': 'اكتب رقم بطاقة الموقع أو رقم هاتفك، ثم رمز PIN.',
  'si.workspace': 'مساحة العمل',
  'si.card': 'رقم البطاقة أو الهاتف',
  'si.pin': 'رمز PIN',
  'si.emailRequired': 'اكتب بريدك أو هاتفك.',
  'si.passwordRequired': 'اكتب كلمة المرور.',
  'si.pinRequired': 'اكتب رمز PIN من 4 إلى 6 أرقام.',
  'si.cardRequired': 'اكتب رقم البطاقة أو الهاتف.',
  'si.failed': 'لم ينجح ذلك. تحقق من البيانات وحاول مرة أخرى.',
  'si.signingIn': 'جارٍ تسجيل الدخول…',
  'persona.owner': 'الرئيسية مع التقرير الأسبوعي',
  'persona.ownersup': 'الموافقات وزيارات الموقع',
  'persona.supervisor': 'اليوم: الحضور واليومية',
  'persona.store': 'المخازن: الاستلام والصرف',
  'persona.accounts': 'المال: الفواتير والمدفوعات',
  'persona.partner': 'مشاريع عملائه فقط',
  'role.partnerShort': 'المقاول (شريك)',

  'c.save': 'حفظ',
  'c.cancel': 'إلغاء',
  'c.close': 'إغلاق',
  'c.add': 'إضافة',
  'c.edit': 'تعديل',
  'c.delete': 'حذف',
  'c.back': 'رجوع',
  'c.next': 'التالي',
  'c.done': 'تم',
  'c.approve': 'موافقة',
  'c.decline': 'رفض',
  'c.send': 'إرسال',
  'c.retry': 'حاول مرة أخرى',
  'c.loading': 'جارٍ التحميل…',
  'c.error': 'حدث خطأ ما.',
  'c.empty': 'لا شيء هنا بعد.',
  'c.search': 'بحث',
  'c.all': 'الكل',
  'c.export': 'تصدير',
  'c.download': 'تنزيل',
  'c.copy': 'نسخ الرابط',
  'c.copied': 'تم النسخ',
  'c.share': 'مشاركة',
  'c.whatsapp': 'إرسال عبر واتساب',
  'c.open': 'فتح',
  'c.saved': 'تم الحفظ',
  'c.photo': 'صورة',
  'c.addPhoto': 'إضافة صورة',
  'c.today': 'اليوم',
  'c.later': 'لاحقاً',
  'c.laterNote': 'مخطط له في إصدار لاحق. لا شيء هنا بعد.',
  'c.required': 'مطلوب',
  'c.offline': 'غير متصل: محفوظ على هذا الجهاز ويُرسل عند عودة الاتصال',
  'c.print': 'طباعة',
  'c.undo': 'تراجع',
  'c.optional': 'اختياري',
  'c.uploading': 'جارٍ الرفع…',
  'c.noAccess': 'ليست لديك صلاحية لهذه الصفحة.',
  'c.notFound': 'الصفحة غير موجودة.',
  'c.goHome': 'الذهاب إلى صفحة البداية',

  'm.today': 'اليوم',
  'm.scan': 'مسح',
  'm.add': 'إضافة',
  'm.inbox': 'الوارد',
  'm.more': 'المزيد',
  'm.morning': 'صباح الخير، {name}',
  'm.afternoon': 'مرحباً، {name}',
  'm.evening': 'مساء الخير، {name}',
  'm.allSent': 'تم إرسال الكل',
  'm.onSite': 'في الموقع',
  'm.notYet': '{n} لم يحضروا بعد',
  'm.waterTank': 'خزان المياه',
  'm.tankRead': 'قراءة {time}',
  'm.noTank': 'لا توجد قراءة بعد',
  'm.deliveries': 'التوريدات',
  'm.deliveriesSub': 'تم استلام {n} اليوم',
  'm.lowStock': 'مخزون منخفض',
  'm.lowSub': 'تبقى {qty} من {item}',
  'm.doNext': 'التالي',
  'm.scanCard': 'مسح البطاقة',
  'm.receive': 'استلام',
  'm.voiceNote': 'ملاحظة صوتية',
  'm.nothingNext': 'لا شيء بانتظارك. أحسنت.',
  'm.markNotIn': 'سجّل حالة الـ {n} الذين لم يحضروا',
  'm.markNotInSub': 'متأخر أو غائب أو في إجازة · قبل 09:00',
  'm.due': 'الموعد {date}',
  'm.addTitle': 'إضافة إلى سجل الموقع',
  'add.receive': 'استلام توريد',
  'add.issue': 'صرف للعمل',
  'add.water': 'صهريج مياه',
  'add.debris': 'شاحنة مخلفات',
  'add.diary': 'ملاحظة يومية بالصوت',
  'add.photo': 'صورة تقدم العمل',
  'add.bill': 'فاتورة أو إيصال',
  'add.petty': 'عهدة نقدية',

  'scan.title': 'مسح بطاقة الموقع',
  'scan.gate': '{project} · البوابة',
  'scan.in': 'دخول',
  'scan.out': 'خروج',
  'scan.comingIn': 'دخول',
  'scan.goingOut': 'خروج',
  'scan.hold': 'ضع البطاقة داخل الإطار',
  'scan.holdOut': 'خروج: ضع بطاقة الموقع داخل الإطار',
  'scan.faceNote': 'تلتقط الكاميرا أيضاً صورة للوجه للسجل',
  'scan.usePin': 'استخدام PIN',
  'scan.noCard': 'لا بطاقة؟ استخدم PIN',
  'scan.torch': 'المصباح',
  'scan.typeCode': 'اكتب رقم البطاقة',
  'scan.onSite': 'في الموقع حسب GPS',
  'scan.offSite': 'GPS خارج الموقع',
  'scan.noGps': 'لا يوجد GPS',
  'scan.photoSaved': 'تم حفظ الصورة',
  'scan.noPhoto': 'بلا صورة',
  'scan.day': 'اليوم {n} هذا الشهر',
  'scan.next': 'البطاقة التالية',
  'scan.noCamera': 'الكاميرا غير متاحة. اكتب رقم البطاقة أو استخدم PIN.',
  'scan.cardNo': 'رقم البطاقة',
  'scan.worker': 'العامل',
  'scan.pinTitle': 'الدخول أو الخروج برمز PIN',
  'scan.record': 'تسجيل',
  'scan.undone': 'تمت الإزالة. امسح مرة أخرى عند الاستعداد.',
  'scan.close': 'إغلاق',
  'scan.waiting': 'بانتظار بطاقة',

  'recv.title': 'استلام توريد',
  'recv.step1': 'الخطوة 1 من 2 · إذن التسليم',
  'recv.step2': 'الخطوة 2 من 2 · تحقق مما وصل',
  'recv.notePhoto': 'صورة إذن التسليم',
  'recv.takeNote': 'التقط صورة لإذن التسليم',
  'recv.supplier': 'المورد',
  'recv.noteNo': 'رقم إذن التسليم',
  'recv.order': 'أمر الشراء',
  'recv.noOrder': 'وصل دون أمر شراء',
  'recv.matched': 'مطابق لأمر الشراء {order}',
  'recv.what': 'ما الذي وصل',
  'recv.ordered': 'المطلوب {q}',
  'recv.short': 'ناقص {n} {unit}: تم إبلاغ المورد وستُراجع الفاتورة',
  'recv.goods': 'صورة البضاعة',
  'recv.draft': 'حفظ كمسودة',
  'recv.addStock': 'إضافة إلى المخزون',
  'recv.addLine': 'إضافة صنف',
  'recv.item': 'الصنف',
  'recv.qty': 'الكمية المستلمة',
  'recv.less': 'أقل',
  'recv.more': 'أكثر',
  'recv.noteRequired': 'صورة إذن التسليم مطلوبة حسب قواعد مساحة العمل.',
  'recv.goodsRequired': 'صورة البضاعة مطلوبة حسب قواعد مساحة العمل.',
  'recv.noLines': 'أضف صنفاً واحداً على الأقل مع الكمية.',
  'recv.done': 'أضيف إلى المخزون: {n} بنود.',
  'recv.draftSaved': 'حُفظت المسودة على هذا الجهاز.',
  'recv.by': '{name} · {time}',

  'lang.en': 'الإنجليزية',
  'lang.ur': 'الأردية',
  'lang.ar': 'العربية',
  'diary.title': 'يومية الموقع',
  'diary.voice': 'ملاحظة صوتية · {name}',
  'diary.note': 'ملاحظة · {name}',
  'diary.photos': '{n} صور للتقدم · {name}',
  'diary.ai': 'كتبها الذكاء الاصطناعي من {lang} · راجعها',
  'diary.hold': 'اضغط مطولاً للتحدث',
  'diary.recording': 'جارٍ التسجيل… اترك الزر للإرسال',
  'diary.tapMode': 'اضغط للبدء واضغط مرة أخرى للإرسال',
  'diary.type': 'أو اكتب ملاحظة…',
  'diary.send': 'إرسال الملاحظة',
  'diary.play': 'تشغيل الملاحظة الصوتية',
  'diary.pause': 'إيقاف مؤقت',
  'diary.mic': 'الميكروفون محجوب. اسمح به في المتصفح أو اكتب الملاحظة.',
  'diary.saved': 'أضيفت إلى اليومية.',
  'diary.empty': 'لا توجد إدخالات في هذا اليوم بعد.',
  'diary.uploading': 'جارٍ إرسال الملاحظة الصوتية…',
  'diary.short': 'قصيرة جداً: اضغط على الزر أثناء الحديث.',

  'owner.house': 'منزلك',
  'owner.week': '{week}',
  'owner.handover': 'وفق الخطة للتسليم في {date}',
  'owner.from': 'هذا الأسبوع من {name}',
  'owner.spent': 'المصروف هذا الأسبوع',
  'owner.under': 'أقل من الخطة بـ {amt}',
  'owner.over': 'أكثر من الخطة بـ {amt}',
  'owner.nextPay': 'الدفعة التالية',
  'owner.stageDue': 'المرحلة {n} · مستحقة {date}',
  'owner.nothingDue': 'لا شيء مستحق',
  'owner.needsYes': 'بانتظار موافقتك',
  'owner.ask': 'اسأل {name}',
  'owner.more': '{n} آخر: {title}، {amt}',
  'owner.days': '{n} أيام إضافية',
  'owner.noDays': 'لا تغيير في تاريخ الإنجاز',
  'owner.built': 'تم بناء {n} بالمئة',
  'owner.photos': 'الصور',
  'owner.invoices': 'الفواتير ودفعات المراحل',
  'owner.changes': 'أوامر التغيير',
  'owner.paid': 'مدفوعة',
  'owner.due': 'مستحقة {date}',
  'owner.notYet': 'ليس بعد',
  'owner.approved': 'موافق عليه',
  'owner.declined': 'مرفوض',
  'owner.waiting': 'بانتظارك',
  'owner.note': 'ملاحظة للمقاول',
  'owner.confirmApprove': 'الموافقة على {number} بمبلغ {amt}؟',
  'owner.confirmDecline': 'رفض {number}؟',
  'owner.thanks': 'شكراً. تم إرسال ردك إلى المقاول.',
  'owner.noUpdate': 'التقرير الأسبوعي غير جاهز بعد.',
  'owner.allDone': 'لا شيء بانتظار ردك.',
  'client.shared': 'مشاركة من {workspace} عبر Buildiary',
  'client.private': 'لا حاجة لتسجيل الدخول. هذا الرابط لك وحدك؛ يرجى عدم مشاركته.',
  'client.bad': 'انتهت صلاحية هذا الرابط أو أنه غير صحيح. اطلب رابطاً جديداً من المقاول.',
  'client.stage': 'الآن: {stage}',
  'client.progress': 'التقدم',
  'client.total': 'الإجمالي',
  'client.amount': 'المبلغ',
  'client.lines': 'ما الذي سيتغير',
  'supplier.title': 'كشف حساب {name}',
  'supplier.orders': 'الطلبات',
  'supplier.bills': 'الفواتير',
  'supplier.payments': 'المدفوعات',
  'supplier.balance': 'الرصيد المستحق لك',
  'supplier.from': 'من {workspace}',

  'wk.title': 'التقرير الأسبوعي للمالك',
  'wk.draftedAi': 'أعدّه الذكاء الاصطناعي · راجِعه قبل الإرسال',
  'wk.draftedTemplate': 'من القالب · راجِعه قبل الإرسال',
  'wk.sends': 'يُرسل {when} عبر واتساب والبريد',
  'wk.checkSend': 'مراجعة وإرسال',
  'wk.sent': 'أُرسل {when}',
  'owner.sentOn': 'أُرسل {when}',
  'si.at': 'تسجيل الدخول إلى {name}',
  'si.notYou': 'ليست مساحة عملك؟',
  'si.find': 'ابحث عن مساحة عملي',
  'si.start': 'ابدأ تجربة مجانية',
  'nows.title': 'لا توجد مساحة عمل على هذا العنوان',
  'nows.text': 'تحقق من الاسم في العنوان، مثل alnoor.buildiary.app. إذا نسيته يمكننا إرساله إليك بالبريد.',
  'nows.site': 'عن بلدائري',
  'my.title': 'موقع البناء في جوالك.',
  'my.lead': 'ابدأ تجربة مجانية، أو ابحث عن عنوان مساحة عملك.',
  'my.go': 'الذهاب إلى مساحة عملي',
  'my.goHint': 'اكتب اسم مساحة عملك',
  'my.console': 'فريق إس إم إتش: لوحة التحكم',
  'find.title': 'ابحث عن مساحة عملي',
  'find.lead': 'اكتب البريد الذي تسجّل الدخول به. سنرسل إليك عنوان كل مساحة عمل تنتمي إليها.',
  'find.email': 'بريدك الإلكتروني',
  'find.send': 'أرسل لي الروابط',
  'st.title': 'ابدأ تجربتك المجانية',
  'st.lead': '{days} يومًا مجانًا. لا بطاقة ولا خصم تلقائي: تدفع بالتحويل البنكي فقط عندما تقرر الاستمرار.',
  'st.what': 'ماذا تبني؟',
  'st.owner': 'بيتي الخاص',
  'st.builder': 'مشاريع لعملائي',
  'st.perMonth': '{price} شهريًا',
  'st.perYear': 'أو {price} سنويًا',
  'st.limits': '{projects} مشاريع · {users} أشخاص',
  'st.data': 'كيف تريد أن تبدأ؟',
  'st.empty': 'فارغة، بمشروعي الخاص',
  'st.sample': 'مع بيانات تجريبية لبلدي',
  'st.name': 'اسمك',
  'st.email': 'البريد الإلكتروني',
  'st.country': 'الدولة',
  'st.phone': 'الجوال (واتساب)',
  'st.company': 'اسم مساحة العمل',
  'st.companyHint': 'شركتك، أو البيت الذي تبنيه',
  'st.address': 'العنوان',
  'st.free': 'متاح',
  'st.agree': 'أوافق على الشروط وسياسة الخصوصية',
  'st.terms': 'الشروط',
  'st.go': 'ابدأ تجربتي المجانية',
  'st.checkTitle': 'تحقق من بريدك',
  'st.checkLead': 'أرسلنا رمزًا من 6 أرقام إلى {email}. اكتبه هنا، أو افتح الرابط في الرسالة.',
  'st.mailOff': 'سيرسل لك فريقنا الرمز قريبًا (بالبريد أو واتساب).',
  'st.code': 'الرمز',
  'st.confirm': 'تأكيد وفتح مساحة عملي',
  'st.resend': 'أرسل رمزًا جديدًا',
  'st.resent': 'أُرسل رمز جديد.',
  'st.opening': 'مساحة عملك جاهزة. جارٍ فتحها…',
  'st.ready': 'مساحة عملك جاهزة',
  'st.openIt': 'افتح {host}',
  'st.closed': 'التسجيلات الجديدة مغلقة حاليًا. يرجى التواصل معنا.',
  'st.have': 'لديك مساحة عمل؟',
  'plan.trialLeft': 'التجربة المجانية: بقي {n} يوم.',
  'plan.trialLast': 'التجربة المجانية: اليوم هو اليوم الأخير.',
  'plan.paidLeft': 'تنتهي خطتك بعد {n} يوم.',
  'plan.ended': 'انتهت تجربتك المجانية. كل شيء محفوظ ويمكن قراءته؛ لا يمكن إضافة جديد حتى تُدفع الخطة.',
  'plan.endedPaid': 'انتهت خطتك. كل شيء محفوظ ويمكن قراءته؛ لا يمكن إضافة جديد حتى يتم تجديدها.',
  'plan.pay': 'الخطة والفوترة',
  'plan.askOwner': 'اطلب من المالك تجديدها.',
  'top.changeWorkspace': 'تغيير مساحة العمل',
  'scan.native': 'امسح البطاقة',
};
